/**
 * Created by josej on 08/09/2016.
 */
$(function(){
    /**
     * Funções do Video
     * */
    $('.video-container i').click(function(){
        loadVideo();
    });

    $('.btn-quotation').click(function(){
        $('html,body').stop().animate({scrollTop: $('#formulario').offset().top}, 2000);
    });

    $('#youtube').click(function(){
        loadVideo();
    });

    $('#form-quotation').submit(function(){
        $("#loading").show();
    });


    function loadVideo(){
        video =  $('#youtube').attr('data-video');
        $('#youtube').remove();
        $('.video-container').html('<iframe width="1170" height="658" src="https://www.youtube.com/embed/'+video+'?rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>');
    }
});